"use strict";
/**
 * Created by MRQ on 2016/1/8.
 */
angular.module("mangeProAppChannelCtrlModule", [])
    .controller('appchannelDeleteCtrl', ['$scope', "$modalInstance", "item", "successFn", "productMangageMentAppService", function($scope, $modalInstance, item, successFn, productMangageMentAppService) {
        init();
        $scope.cancel = function() {
            $scope.$close();
        };
        $scope.confirm = function() {
            $modalInstance.close({});
        };
        $scope.deleteToggle = function() {
            $scope.isDeleteFirst = true;
        };

        function init() {
            $scope.item = item;
            $scope.isDeleteFirst = false;
        }
    }])
    .controller("appchannelModifyCtrl", ["$scope", "$stateParams", "$modalInstance", "$modal", "$validation", "column", "successFn", "initManageConSelectedService", "productMangageMentAppService", "appChannel", "trsHttpService", "modalDialog", function($scope, $stateParams, $modalInstance, $modal, $validation, column, successFn, initManageConSelectedService, productMangageMentAppService, appChannel, trsHttpService, modalDialog) {
        initStatus();
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            $validation.validate($scope.createChlForm).success(function() {
                if ($scope.isChnlExist == '"true"') {
                    modalDialog.alertType("栏目唯一标识已经存在", "", "error", false);
                    return;
                }
                if ($scope.savePos == 'false') {
                    modalDialog.alertType("存放位置已存在", "", "error", false);
                    return;
                }
                $scope.channel.CHNLORDER = $scope.selectedWebChannel.value;
                if ($scope.channel.APPOPERTYPE.length === 0) {
                    modalDialog.alertType("请至少选择一种稿件类型", "", "error", false);
                    return;
                }
                $scope.channel.APPOPERTYPE = $scope.channel.APPOPERTYPE.join();
                $modalInstance.close($scope.channel);
            }).error(function() {
                $scope.showAllTips = true;
            });
        };
        //检测存放位置
        $scope.examinePos = function() {
            $scope.isShowTipsSiteName = false;
            var posParams = {
                serviceid: "mlf_websiteconfig",
                methodname: "checkChannelPath",
                Siteid: $stateParams.site,
                ChannelId: $scope.channel.OBJECTID,
                DataPath: $scope.channel.DATAPATH,
                ParentId: "0"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), posParams, "get").then(function(data) {
                $scope.savePos = data;
            });
        };
        /**
         * [setDraftTypes description] 设置栏目下稿件新建类型
         * @param  {[string]} typeValue [description] 类型值
         * @return {[type]} [description]
         */
        $scope.setDraftTypes = function(typeValue) {
            // typeValue = parseInt(typeValue);
            var index = $scope.channel.APPOPERTYPE.indexOf(typeValue);
            if (index >= 0) {
                $scope.channel.APPOPERTYPE.splice(index, 1);
            } else {
                $scope.channel.APPOPERTYPE.push(typeValue);
            }
        };
        /**
         * [isIncludedDraftType description] 判断是否包含该稿件类型
         * @param  {[string]} typeValue [description] 类型值
         * @return {[type]} [description]
         */
        $scope.isIncludedDraftType = function(typeValue) {
            // typeValue = parseInt(typeValue);
            return $scope.channel.APPOPERTYPE.indexOf(typeValue) >= 0;
        };
        /**
         * [attrAllChecks description] 稿件属性复选框
         * @param  {[type]} attr [description]
         * @return {[type]}      [description]
         */
        /*$scope.attrAllChecks = function(attr) {
            if(attr == 'CHNLTYPE') {
                $scope.channel[attr] = $scope.channel[attr] == 28 ? 0 : 28;
            } else {
                $scope.channel[attr] = $scope.channel[attr] == 1 ? 0 : 1;
            }
        };*/
        /**
         * [checkTempName description] 校验唯一标识是否已经存在
         * @return {[type]} [description]
         */
        $scope.checkIdentify = function() {
            if ($scope.channel.CHNLNAME == $scope.thisChnlName || $scope.channel.CHNLNAME === "") return;
            var params = {
                serviceid: "mlf_appconfig",
                methodname: "checkChannelNameExists",
                CHNLNAME: $scope.channel.CHNLNAME,
                SITEID: $stateParams.site,
                CHANNELID: $scope.thisChnlId || "0"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.isChnlExist = data;
            });
        };

        function initEditData() {
            $scope.params = {
                serviceid: "mlf_appconfig",
                methodname: "findChannelById",
                TopChannelId: '0',
                ChannelId: appChannel.CHANNELID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                $scope.channel = {
                    OBJECTID: data.CHANNELID,
                    SITEID: $stateParams.site,
                    CHNLNAME: data.CHNLNAME,
                    CHNLDESC: data.CHNLDESC,
                    PARENTID: data.PARENTID,
                    CHNLORDER: -1,
                    DATAPATH: data.DATAPATH,
                    ROOTDOMAIN: data.ROOTDOMAIN,
                    APPOPERTYPE: data.APPOPERTYPE === "" || data.APPOPERTYPE === undefined ? [] : data.APPOPERTYPE.split(","),
                    CHNLTYPE: data.CHNLTYPE,
                    TEMPID: {
                        CHNLTEMPID: 0,
                        OTHERTEMPID: 0,
                        DOCTEMPID: 0
                    }
                };
                $scope.thisChnlName = data.CHNLNAME;
                $scope.thisChnlId = data.CHANNELID;
                $scope.channel.TEMPID.CHNLTEMPID = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPID : "0";
                $scope.channel.TEMPID.OTHERTEMPID = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPID : "0";
                $scope.channel.TEMPID.DOCTEMPID = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPID : "0";
                $scope.tempName.channelTempName = angular.isDefined(data.GAILANTEMP[0]) ? data.GAILANTEMP[0].TEMPNAME : "";
                $scope.tempName.otherTempName = angular.isDefined(data.OTHERTEMP[0]) ? data.OTHERTEMP[0].TEMPNAME : "";
                $scope.tempName.articleTempName = angular.isDefined(data.DOCTEMP[0]) ? data.DOCTEMP[0].TEMPNAME : "";
                var i = 0;
                while (i < $scope.appChannelsJson.length) {
                    if ($scope.appChannelsJson[i].value === data.CHNLORDER) {
                        $scope.appChannelsJson.splice(i, 1);
                        $scope.selectedWebChannel = angular.copy($scope.appChannelsJson[i - 1]);
                    } else {
                        i++;
                    }
                }
            });
        }

        function initStatus() {
            $scope.channel = {
                OBJECTID: 0,
                SITEID: $stateParams.site,
                CHNLNAME: "",
                CHNLDESC: "",
                PARENTID: "0",
                CHNLORDER: -1,
                DATAPATH: "",
                ROOTDOMAIN: "",
                APPOPERTYPE: ["1", "2", "3", "4", "5", "6", "7", "8", "12", "13"],
                CHNLTYPE: 0,
                TEMPID: {
                    CHNLTEMPID: 0,
                    OTHERTEMPID: 0,
                    DOCTEMPID: 0
                }
            };
            $scope.tempName = {
                channelTempName: "",
                otherTempName: "",
                articleTempName: ""
            };
            $scope.column = column;
            $scope.isChnlExist = '"false"'; //校验唯一标识是否已经存在
            $scope.savePos = 'true'; //校验存放位置是否已经存在
            initAllChannels();
        }

        function initAllChannels() {
            initManageConSelectedService.getAppAllChannels($stateParams.site).then(function(data) {
                $scope.appChannelsJson = data;
                $scope.appChannelsJson.unshift({
                    name: "最前面",
                    value: -1
                });
                $scope.selectedWebChannel = angular.copy($scope.appChannelsJson[0]);
                appChannel !== "" ? initEditData() : "";
            });
        }
        //获取前一级栏目
        $scope.querySelectChl = function() {
            $scope.channel.CHNLORDER = $scope.selectedWebChannel.value;
        };
        /**
         * [chnlOtherTemplate description]栏目其他模板点击
         * @return {[type]} [description]
         */
        $scope.chnlOtherTemplate = function() {
            queryTemplate(1, 'OTHERTEMPID', 'otherTempName');

        };
        /**
         * [chnlTemplate description]栏目模板点击
         * @return {[type]} [description]
         */
        $scope.chnlTemplate = function() {
            queryTemplate(1, 'CHNLTEMPID', 'channelTempName');
        };
        /**
         * [defaultArticleTemplate description]默认模板点击
         * @return {[type]} [description]
         */
        $scope.defaultArticleTemplate = function() {
            queryTemplate(2, 'DOCTEMPID', 'articleTempName');
        };
        /**
         * [queryTemplate description]模板弹窗打开
         * @param  {[type]} TEMPLATETYPE [description]
         * @return {[type]}              [description]
         */
        function queryTemplate(TEMPLATETYPE, ID, Name) {
            var params = {
                ObjectType: $scope.channel.OBJECTID > 0 ? '101' : '103',
                ObjectId: $scope.channel.OBJECTID > 0 ? $scope.channel.OBJECTID : $scope.channel.SITEID,
                TEMPLATETYPE: TEMPLATETYPE,
                TempName: "",
                selectedTempId: $scope.channel.TEMPID[ID],
                selectedTempName: $scope.tempName[Name],
            };
            productMangageMentAppService.bindTemplate(params, function(result) {
                $scope.channel.TEMPID[ID] = result.TEMPID;
                $scope.tempName[Name] = result.TEMPNAME;
            });
        }
    }]);